import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = '7thaven';

	@HostListener('document:wheel', ['$event'])
	preventNumberInputWheel(event: WheelEvent): void {
	  const input = event.target as HTMLInputElement | null;
	  if (input?.tagName === 'INPUT' && input.type === 'number' && document.activeElement === input) {
		input.blur();
	  }
	}
}
